import React from "react";
import * as style from "./styles.module.scss";

const Pagination = ({
  itemsPerPage,
  totalItems,
  currentPage,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const visiblePages = 3;
  const options = [5, 10, 20];
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startPage = Math.max(currentPage - Math.floor(visiblePages / 2) + 1, 1); // odd only
  const endPage = Math.min(startPage + visiblePages - 1, totalPages);

  const handlePageChange = (page) => {
    onPageChange(page);
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    const newTotalPages = Math.ceil(totalItems / newItemsPerPage);
    const newCurrentPage = Math.min(currentPage, newTotalPages);
    onItemsPerPageChange(newItemsPerPage);
    onPageChange(newCurrentPage);
  };

  const renderOptions = () => {
    return options.map((option) => (
      <option key={option} value={option}>
        {option}
      </option>
    ));
  };

  const renderPageButton = (pageNumber, label = pageNumber) => {
    return (
      <button
        key={pageNumber}
        onClick={() => handlePageChange(pageNumber)}
        className={`${style.pageButton} ${
          pageNumber === currentPage ? style.active : ""
        }`}
      >
        {label}
      </button>
    );
  };

  const renderEllipsis = () => {
    return <span className={style.ellipsis}>...</span>;
  };

  const renderPreviousButton = () => {
    return (
      <button
        className={`${style.pageButton} ${
          currentPage === 1 ? style.disabled : ""
        }`}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        &laquo;
      </button>
    );
  };

  const renderNextButton = () => {
    return (
      <button
        className={`${style.pageButton} ${
          currentPage === totalPages ? style.disabled : ""
        }`}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        &raquo;
      </button>
    );
  };

  const renderFirstPageButton = () => {
    return (
      <>
        {renderPageButton(1)}
        {startPage > 2 && renderEllipsis()}
      </>
    );
  };

  const renderLastPageButton = () => {
    return (
      <>
        {endPage < totalPages && renderEllipsis()}
        {renderPageButton(totalPages)}
      </>
    );
  };

  const renderPages = () => {
    return Array.from({ length: endPage - startPage + 1 }).map((_, index) => {
      const pageNumber = startPage + index;
      if (
        pageNumber === endPage &&
        endPage !== totalPages &&
        currentPage !== endPage
      ) {
        return null;
      }
      return renderPageButton(pageNumber);
    });
  };

  return (
    <div className={style.pagination}>
      <div className={style.itemsPerPage}>
        <label htmlFor="itemsPerPage" className={style.paginationLabel}>
          Items per page:
        </label>
        <select
          name="itemsPerPage"
          id="itemsPerPage"
          value={itemsPerPage}
          onChange={handleItemsPerPageChange}
          className={style.select}
        >
          {renderOptions()}
        </select>
      </div>
      {totalItems > itemsPerPage && (
        <>
          {renderPreviousButton()}
          {startPage > 1 && renderFirstPageButton()}
          {renderPages()}
          {endPage < totalPages && renderLastPageButton()}
          {renderNextButton()}
        </>
      )}
    </div>
  );
};

export default Pagination;
